export default __webpack_public_path__ + "static/media/login-visual7.b4f15ddb.jpg";